// React bindings for the session store. Each hook selects ONE referentially
// stable field via useSyncExternalStore, so a high-frequency level tick never
// re-renders the transcript list and vice-versa. (We avoid object-literal
// selectors on purpose — they'd return a new value every call and loop.)

import { useSyncExternalStore } from 'react'
import type { SessionStore } from './sessionStore'

export function useFinals(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().finals)
}

export function useInterim(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().interim)
}

export function useSpeakers(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().speakers)
}

export function useConnection(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().connection)
}

export function useConnectionDetail(store: SessionStore) {
  return useSyncExternalStore(
    store.subscribe,
    () => store.getSnapshot().connectionDetail
  )
}

export function useError(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().error)
}

export function useLevel(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().level)
}

export function useSessionTitle(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().title)
}

export function useAiStatus(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().aiStatus)
}

export function useAiDetail(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().aiDetail)
}

export function useAiTurns(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().aiTurns)
}

export function useAiPresence(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().aiPresence)
}

export function useDelivery(store: SessionStore) {
  return useSyncExternalStore(store.subscribe, () => store.getSnapshot().delivery)
}
